export const formatCurrency = (amountCents: number, currency = "USD"): string =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
  }).format(amountCents / 100);

export const formatDate = (value: string): string =>
  new Intl.DateTimeFormat("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  }).format(new Date(value));

export const formatAmountInputToCents = (value: string): number | null => {
  if (!value.trim()) {
    return null;
  }

  const normalized = Number(value.replace(/[^0-9.]/g, ""));

  if (!Number.isFinite(normalized) || normalized <= 0) {
    return null;
  }

  return Math.round(normalized * 100);
};
